module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.flag) ? _c('div', {
    staticClass: "cover"
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag && _vm.language == 0),
      expression: "flag && language==0"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("登录")]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.closeLogin
    }
  }, [_c('icon', {
    attrs: {
      "iconClass": "fa-times"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('Form', {
    ref: "formLoginPhone",
    attrs: {
      "model": _vm.phoneLogin,
      "rules": _vm.rulePhoneLogin,
      "label-width": 120
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "phone",
      "label": "手机号码"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号码"
    },
    model: {
      value: (_vm.phoneLogin.phone),
      callback: function($$v) {
        _vm.$set(_vm.phoneLogin, "phone", $$v)
      },
      expression: "phoneLogin.phone"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "code",
      "label": "验证码"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.phoneLogin.code),
      callback: function($$v) {
        _vm.$set(_vm.phoneLogin, "code", $$v)
      },
      expression: "phoneLogin.code"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "yan",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "login-box"
  }, [_c('Button', {
    attrs: {
      "type": "error"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit('formLoginPhone')
      }
    }
  }, [_vm._v("登录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "yan2"
  }, [_vm._v("\n          收不到验证码? 试试 "), _c('span', {
    on: {
      "click": _vm.getYuCode
    }
  }, [_vm._v("语音验证码")])])], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag && _vm.language == 1),
      expression: "flag && language==1"
    }],
    staticClass: "box email-box"
  }, [(_vm.regMsg) ? _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("sign in")]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.closeLogin
    }
  }, [_c('icon', {
    attrs: {
      "iconClass": "fa-times"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('Form', {
    ref: "formLoginEmail",
    attrs: {
      "model": _vm.emailLogin,
      "rules": _vm.ruleEmailLogin,
      "label-width": 120
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "email",
      "label": "email"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "please type your email"
    },
    model: {
      value: (_vm.emailLogin.email),
      callback: function($$v) {
        _vm.$set(_vm.emailLogin, "email", $$v)
      },
      expression: "emailLogin.email"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password",
      "label": "password"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "password",
      "placeholder": "please type your email"
    },
    model: {
      value: (_vm.emailLogin.password),
      callback: function($$v) {
        _vm.$set(_vm.emailLogin, "password", $$v)
      },
      expression: "emailLogin.password"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "login-box email-login"
  }, [_c('Button', {
    attrs: {
      "type": "error"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit('formLoginEmail')
      }
    }
  }, [_vm._v("sign in")])], 1), _vm._v(" "), _c('div', {
    staticClass: "reg-box"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.regShow
    }
  }, [_vm._v("Create an account")])])]) : _vm._e(), _vm._v(" "), (!_vm.regMsg) ? _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("sign up")]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.closeLogin
    }
  }, [_c('icon', {
    attrs: {
      "iconClass": "fa-times"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "reg-container"
  }, [_c('Form', {
    ref: "formCustom",
    attrs: {
      "model": _vm.formCustom,
      "rules": _vm.ruleCustom,
      "label-width": 120
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "email",
      "label": "email"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "please type your email"
    },
    model: {
      value: (_vm.formCustom.email),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "email", $$v)
      },
      expression: "formCustom.email"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password",
      "label": "password"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "password",
      "placeholder": "please type your Password"
    },
    model: {
      value: (_vm.formCustom.password),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "password", $$v)
      },
      expression: "formCustom.password"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "passwdCheck",
      "label": "confirm"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "password",
      "placeholder": "plaese confirm your Password"
    },
    model: {
      value: (_vm.formCustom.passwdCheck),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "passwdCheck", $$v)
      },
      expression: "formCustom.passwdCheck"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "error"
    },
    on: {
      "click": function($event) {
        _vm.handleSubmit('formCustom')
      }
    }
  }, [_vm._v("sign up")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        _vm.handleReset('formCustom')
      }
    }
  }, [_vm._v("reset")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "reg-box"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.loginShow
    }
  }, [_vm._v("sign in")])])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ac42b9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl1/iLogin/iLogin.vue
// module id = 818
// module chunks = 10